import { NOTNULL_OR_NOTUNDEFINED } from "./EmpUtil";

/**
 * @return {string}
 */

export default function PositiveValue(value) {
  if (NOTNULL_OR_NOTUNDEFINED(value)) {
    value = value < 0 ? value * -1 : value;
  } else {
    value = "0";
  }
  return value;
}
